import Axios from '../axios-instance';

const ClaimsAPI = {
  getClaims: body => {
    return Axios.post('/Claims/getall', body).then(({ data }) => data);
  },
  getFile: (id, fileName) => {
    return Axios.get(`/Claims/${id}/${fileName}`).then(({ data }) => data);
  },
  getClaimDetails: id => {
    return Axios.get(`/Claims/${id}`).then(({ data }) => data);
  },
  deriveClaim: (id, body) => {
    return Axios.put(`/Claims/${id}`, body).then(({ data }) => data);
  },
  startClaim: body => {
    return Axios.post('/Claims', body).then(({ data }) => data);
  },
  uploadFile: (id, files) => {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });

    return Axios.post(`/Claims/${id}/File`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then(({ data }) => data);
  },
  getPaymentMethod: cuit => {
    return Axios.get(`/PaymentMethod/${cuit}`).then(({ data }) => data);
  },
  getPendingAndAccounted: cuit => {
    return Axios.get(`/AccountStatement/GetPendingAndAccounted/${cuit}`).then(({ data }) => data);
  },
};

export default ClaimsAPI;
